import { Sequence, useCurrentFrame } from './remotionRecordlyEngine';

interface RealProductSceneProps {
  primaryStill: string;
  primaryAlt: string;
  secondaryStill: string;
  secondaryAlt: string;
  caption: string;
  switchFrame?: number;
}

function RealProductScene({
  primaryStill,
  primaryAlt,
  secondaryStill,
  secondaryAlt,
  caption,
  switchFrame = 85,
}: RealProductSceneProps) {
  const localFrame = useCurrentFrame();
  const showSecondary = localFrame >= switchFrame;

  return (
    <div className="relative w-full h-full bg-[#F5F5F2] overflow-hidden">
      <img
        src={primaryStill}
        alt={primaryAlt}
        className={`w-full h-full object-cover object-left-top select-none ${showSecondary ? 'hidden' : 'block'}`}
      />
      <img
        src={secondaryStill}
        alt={secondaryAlt}
        className={`w-full h-full object-cover object-left-top select-none ${showSecondary ? 'block' : 'hidden'}`}
      />
      <span className="sr-only">{caption}</span>
    </div>
  );
}

export function RecordlyDemoScenes() {
  return (
    <div className="relative w-full h-full bg-[#F5F5F2]">
      <Sequence from={0} durationInFrames={180}>
        <RealProductScene
          primaryStill="/product-frames/ai-agents.webp"
          primaryAlt="Rooflyzer AI Agents workspace showing Instant Quote Concierge and After-Hours Emergency Dispatch Line"
          secondaryStill="/product-frames/ai-recordings.webp"
          secondaryAlt="Rooflyzer Recordings showing Instant Quote Concierge call audio waveform and transcript"
          caption="Summit Roofing Co. AI Agents: Instant Quote Concierge and After-Hours Emergency Dispatch Line call recording"
        />
      </Sequence>
      <Sequence from={180} durationInFrames={180}>
        <RealProductScene
          primaryStill="/product-frames/estimates.webp"
          primaryAlt="Rooflyzer Measured Roof Estimate showing $14,993.23 total, 2,683 sq ft, 29.5 squares, 6/12 pitch, and linear edge breakdown"
          secondaryStill="/product-frames/roof-3d.webp"
          secondaryAlt="Rooflyzer 3D Roof Viewer showing 6/12 hip roof model with 4 facets and roof line breakdown"
          caption="Measured roof estimate $14,993.23: 2,683 sq ft, 29.5 squares, 6/12 pitch, 104 bundles, 742 Evergreen Terrace"
        />
      </Sequence>
      <Sequence from={360} durationInFrames={180}>
        <RealProductScene
          primaryStill="/product-frames/leads.webp"
          primaryAlt="Rooflyzer Leads workspace showing $208,600 pipeline value and Marcus Whitfield 96 Hot lead"
          secondaryStill="/product-frames/lead-detail.webp"
          secondaryAlt="Rooflyzer Lead Detail for Marcus Whitfield at 4821 Ridgemont Drive, Plano TX 75024 with Send Contract action"
          caption="Marcus Whitfield 4821 Ridgemont Drive, Plano TX 75024 ($24,850) lead detail and Send Contract stage"
          switchFrame={60}
        />
      </Sequence>
      <Sequence from={540} durationInFrames={180}>
        <RealProductScene
          primaryStill="/product-frames/pipeline.webp"
          primaryAlt="Rooflyzer Sales Pipeline 4-stage Kanban board showing $199k pipeline value"
          secondaryStill="/product-frames/invoices.webp"
          secondaryAlt="Rooflyzer Invoices ledger showing IN-20841-1 $13,450 Paid and IN-20841-2 $11,400 Overdue"
          caption="Sales Pipeline ($199k) and Invoices ledger: IN-20841-1 $13,450 Paid and Milestone 2 Tear-Off Draw"
          switchFrame={60}
        />
      </Sequence>
    </div>
  );
}
